import { RouteRecordRaw } from 'vue-router'

const scheduledRoute: Array<RouteRecordRaw> = [
    {
        path: '/scheduled',
        name: 'scheduled',
        redirect: '/scheduled/index',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/scheduled/index',
                name: 'plannedProgress',
                meta: {
                    title: '计划进度',
                    keepAlive: true
                },
                component: () => import('@/views/plannedProgress/index.vue')
            },
            {
                path: '/scheduled/details',
                name: 'progressDetails',
                meta: {
                    title: '计划详情',
                    keepAlive: false
                },
                component: () => import('@/views/plannedProgress/details.vue')
            },
            {
                path: '/distribution/index',
                name: 'distributionIndex',
                meta: {
                    title: '计划分配',
                    keepAlive: true
                },
                component: () => import('@/views/plannedDistribution/index.vue')
            },
            {
                path: '/distribution/assignUsers',
                name: 'distributionAssignUsers',
                meta: {
                    title: '选择',
                    keepAlive: false
                },
                component: () => import('@/views/plannedDistribution/distribution.vue')
            }
        ]
    }
]

export default scheduledRoute
